import React from 'react'
import PropTypes from 'prop-types'
import { Panel } from 'react-bootstrap'
import SVGIcon from '../SVGIcon'

const FAQHeading = ({
  tabIndex,
  name,
  headingStyle,
  iconSrc,
  toggleClassName = ''
}) => {
  return (
    <Panel.Heading style={headingStyle}>
      <Panel.Title tabIndex={tabIndex}>
        <Panel.Toggle
          componentClass="a"
          aria-live="assertive"
          className={toggleClassName}
        >
          {name}
          {iconSrc && <SVGIcon src={iconSrc} className="arrow" />}
        </Panel.Toggle>
      </Panel.Title>
    </Panel.Heading>
  )
}

FAQHeading.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  headingStyle: PropTypes.object,
  iconSrc: PropTypes.string,
  toggleClassName: PropTypes.string
}

export default FAQHeading



// WEBPACK FOOTER //
// ./src/components/FAQ/FAQHeading.js